import React from 'react';
import {BrowserRouter, StaticRouter} from "react-router-dom";

const Router = typeof document !== 'undefined' ? BrowserRouter : StaticRouter;
export default Router;
